/* eslint-disable class-methods-use-this */
class EventSystem {
  constructor() {
    this.queue = {};
  }
  publish(event, data) {
    const customEvent = new CustomEvent(event, {
      detail: data
    });

    // Dispatch the event
    window.dispatchEvent(customEvent);

    // const queue = this.queue[event];

    // if (typeof queue === 'undefined') {
    //     return false;
    // }

    // // while (queue.length > 0) {
    // //     (queue.shift())(data);
    // // }
    // Array.prototype.forEach.call(
    //     queue,
    //     (element) => {
    //         (element)(data);
    //     },
    // );
    return true;
  }
  subscribe(event, callback) {
    window.addEventListener(event, callback);
    // if (typeof this.queue[event] === 'undefined') {
    //     this.queue[event] = [];
    // }

    // this.queue[event].push(callback);
  }

  /** The callback parameter is optional. Without it the whole event will be removed, instead of
   * just one subscription. Enough for simple implementations.
   */
  unsubscribe(event, callback) {
    window.removeEventListener(event, callback);
    // const { queue } = this;

    // if (typeof queue[event] !== 'undefined') {
    //     if (typeof callback === 'undefined') {
    //         delete queue[event];
    //     } else {
    //         this.queue[event] = queue[event].filter(sub => (sub !== callback));
    //     }
    // }
  }
}

// module.exports = new EventSystem();
export default new EventSystem();